import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import React, { useState } from 'react';
import { IPDASetting } from '../../models/IPDASetting.model';
import { process, State } from '@progress/kendo-data-query';
import CommandCell from '../userAdmin/CommandCell';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { locale } from '../../common/localization/localizationService';
import { Checkbox } from 'primereact/checkbox';

export interface IPdaSettingsGridProps {
  data: Array<IPDASetting>;
  className?: string;
  editPdaSetting: (dataItem: IPDASetting) => void;
}

export default function PdaSettingsGrid(
  props: IPdaSettingsGridProps,
): JSX.Element {
  const { editPdaSetting } = props;

  const [dataState, setDataState] = useState<State>({
    sort: [
      {
        dir: 'asc',
        field: 'lastChanged',
      },
    ],
    take: 26,
    skip: 0,
  });

  const dataStateChange = (event: Record<string, any>): void => {
    setDataState(event.data);
  };

  const EditCell = (props: any): JSX.Element => {
    return <CommandCell {...props} edit={editPdaSetting} icon={faEdit} />;
  };

  const getRequiredCell = (gridProps: any) => {
    return (
      <td className="pda-setting-required-cell">
        <Checkbox checked={gridProps.dataItem.required} disabled />
      </td>
    );
  };

  const modifiedData = props.data.map((data) => {
    if (data.lastChanged) {
      data.lastChanged = new Date(data.lastChanged);
    }
    return data;
  });

  const result = process(modifiedData, dataState);

  return (
    <>
      <Grid
        {...dataState}
        className="pda-settings-grid"
        data={result}
        selectedField="selected"
        pageable
        resizable
        pageSize={26}
        onDataStateChange={dataStateChange.bind(this)}
      >
        <GridNoRecords>{locale.pdaSettings._notAnyRecords}</GridNoRecords>
        <GridColumn
          field="parameter"
          title={locale.pdaSettings._parameter}
          filterable
        />
        <GridColumn
          field="value_NO"
          title={locale.pdaSettings._valueNO}
          filterable
        />
        <GridColumn
          field="value_ENG"
          title={locale.pdaSettings._valueENG}
          filterable
        />
        <GridColumn
          field="minValue"
          title={locale.pdaSettings._minValue}
          filterable
        />
        <GridColumn
          field="maxValue"
          title={locale.pdaSettings._maxValue}
          filterable
        />
        <GridColumn
          field="required"
          title={locale.pdaSettings._required}
          cell={getRequiredCell}
          width={95}
          filterable
        />
        <GridColumn
          field="lastChanged"
          title={locale.pdaSettings._lastChanged}
          filterable
          format={'{0:' + locale.general._fullDateWithTime + '}'}
        />
        <GridColumn width={40} cell={EditCell} />
      </Grid>
    </>
  );
}
